import "../_imports/common";
import "../_imports/uppy";
import "../_imports/select2";
import "../_imports/jquery-validation";
import "../_imports/bootstrap-datetimepicker";
import "../_imports/metronic";

// Spotlight
import "spotlight.js/dist/css/spotlight.min.css";

// Font Awesome
import '@fortawesome/fontawesome-free/css/all.css';

// Tema wizard
import "@edith/metronic/sass/theme/pages/wizard/wizard-1.scss";

// Custom
import '../../scss/form.scss';

import { KTUtil, KTWizard, KTApp } from "@edith/metronic/js/demo9";
import { Utils } from "../utils";
import { Core as Uppy } from 'uppy';
import { enableUppyFilePreview } from "../_imports/uppy";
import { ReportField } from "../classes/report-field";
import { File } from "../classes/field-types";

declare const FIELDS: Record<string, any>;
declare const division;

class FormPage {
    // Base elements
	private wizardEl: JQuery;
	private formEl: JQuery;
	private validator: any;
    private wizard: KTWizard;
	private attachments: Uppy.Uppy[];
	private validationRules: any;
	private validationMessages: any;

    // Inizializzazione proprietà
    constructor() {
        this.wizardEl = KTUtil.get('kt_wizard_v1');
        this.formEl = $("#report-form");
		this.attachments = [];
		this.validationRules = {};
		this.validationMessages = {};

        this.initWizard();
		this.initForm();
        this.initValidation();
        this.initSubmit();

		this.bindEvents();
	}

    // Operazioni da eseguire sulla document.ready()
    run() {}

    // Binding agli eventi (richiamata nel costruttore)
    private bindEvents() {
		this.formEl.find(".regenerate-captcha").on("click", () => {
			KTApp.blockPage();

			$.post({
				url: "reload_captcha.php"
			})
			.done((image) => {
				this.formEl.find(".captcha img").attr("src", image);
			})
			.fail(() => {
				Utils.errorSwal("An error occurred while generating the CAPTCHA");
			})
			.always(() => {
				KTApp.unblockPage();
			});
		});
	}

    protected initWizard() {
		// Initialize form wizard
		this.wizard = new KTWizard('kt_wizard_v1', {
			startStep: 1
		});

		if(this.wizard.isFirstStep() && this.wizard.isLastStep()){
			this.formEl.find(".btn[data-ktwizard-type='action-prev']").hide();
			this.formEl.find(".kt-form__actions").css("justify-content", "end");
		}

		if(this.wizard.isLastStep())
			this.formEl.find(".captcha").show();
		else
			this.formEl.find(".captcha").hide();

		// Validation before going to next page
		this.wizard.on('beforeNext', (wizardObj: any) => {
			if (this.validator.form() !== true) {
				wizardObj.stop();  // don't go to the next step
			}
		});

		this.wizard.on('beforePrev', (wizardObj: any) => {
			if (this.validator.form() !== true) {
				wizardObj.stop();  // don't go to the next step
			}
		});

		this.wizard.on('change', () => {
			KTUtil.scrollTop();

			if(this.wizard.isLastStep())
				this.formEl.find(".captcha").show();
			else
				this.formEl.find(".captcha").hide();
		});
    }

	protected initForm(): void {
		FIELDS.forEach(field => {
			const field_type = ReportField.getFieldTypeInstance(
				field.type,
				field.name,
				field.has_other == 1,
				field.required == 1,
				field.multiple == 1,
				field.placeholder,
				field.orientation,
				field.default_value,
                field.additional_options,
                field.additional_validation_rules,
				field.columns
			);

			const element = field_type.initFormElement(this.formEl);
			if(element && field_type instanceof File){
				this.attachments.push(element);
				// Anteprima/scarica al click sulla miniatura del file selezionato
				enableUppyFilePreview(element, field_type.name);
			}

			const rules = field_type.validate(this.formEl);
			const messages = field_type.validationMessages();
			
			let input_name = field_type.name;
			if(field_type.multiple)
				input_name = `${field_type.name}[]`;

			this.validationRules[input_name] = rules["element_validation_rules"];
			if(rules["other_element_validation_rules"]){
				this.validationRules[`${field_type.name}_other`] = rules["other_element_validation_rules"];
			}
			this.validationMessages[input_name] = messages;
		});
	}
	
    private initValidation(): void {
		this.validator = this.formEl.validate({
			rules: this.validationRules,
			messages: this.validationMessages,
			focusInvalid: false,
			invalidHandler: (_form: any, validator: any) => {
				if (!validator.numberOfInvalids())
					return;
		
				$('html, body').animate({
					scrollTop: $(validator.errorList[0].element).closest("div").offset()!.top - $("#kt_header").height()!
				}, 500);
			},
			errorPlacement: function (error, element) {
				if(element.hasClass("select2-hidden-accessible")){
					let new_element = element.next(".select2-container");
					error.insertAfter(new_element);
					new_element = new_element.find(".select2-selection");
					new_element.addClass("select2-error");
					new_element.addClass("is-invalid");
				}
				else{
					error.insertAfter(element);
				}

				element.addClass("is-invalid");
				error.addClass("invalid-feedback");
			},
			unhighlight: function(element, errorClass) {
                if($(element).hasClass("select2-hidden-accessible")){
                    let new_element = $(element).next(".select2-container");
					new_element = new_element.find(".select2-selection");

					new_element.removeClass("select2-error");
					new_element.removeClass("is-invalid");
                }
				else{
					$(element).removeClass("is-invalid");
				}
            },
		});
	}
    
    protected initSubmit() {
		const btn = this.formEl.find('[data-ktwizard-type="action-submit"]');

		btn.on('click', (e) => {
			e.preventDefault();

			if (this.validator.form()) {
				KTApp.blockPage();

				const form = this.formEl.get(0) as HTMLFormElement;
				const formData = new FormData(form);

				this.attachments.forEach(file_input => {
					const files = file_input.getFiles();

					for(let i = 0; i < files.length; i++)
						formData.append(`${file_input.getID()}[${i}]`, files[i].data);
				});

				$.post({
					url: "save.php",
					data: formData,
					processData: false,
					contentType: false
				})
				.done((response) => {
					response = JSON.parse(response);
					if(response.download_submission){
						var a = document.createElement("a"); //Create <a>
						a.href = response.file_pdf; //Pdf Base64 Goes here
						a.download = "submitted_report.pdf"; //File name Here
						a.click(); //Downloaded file
					}
					window.location.href = `success.php?submission_id=${response.submission}`;
				})
				.fail((res) => {
					if(res.status === 401) {
						Utils.errorSwal("Wrong CAPTCHA code!");
						$("input[name='captcha_code'").val("");
					} else {
						Utils.errorSwal("An error occurred while saving the form", "Please verify your Internet connection and retry");
					}
					KTApp.unblockPage();
				});
			}
		});
	}
}

$(() => {
    const page = new FormPage();
    page.run();
});